import * as React from "react";
import {motion} from "framer-motion";
import {MenuItem} from "./MenuItem";
import styled from "styled-components"
import partnerLogo from "../../static/img/findmepartner.svg";
import callSVG from "../../static/navbar/call.svg";
import {
    COMPANY_CALLS_URL, COMPANY_SETTINGS_URL, EMPLOYEE_REQUESTS_URL, EMPLOYEE_SETTINGS_URL,
    EXCLUSIVE_CALL_URL,
    LOGIN_URL,
    MY_CALLS_URL,
    PROFILE_SETTINGS_URL,
    REGISTER_URL
} from "../../constants/URLS";
import coSVG from "../../static/navbar/co.svg";
import settingsSVG from "../../static/navbar/settings.svg";
import loginSVG from "../../static/navbar/login.svg";
import logoutSVG from "../../static/navbar/logout.svg";
import registerSVG from "../../static/navbar/register.svg";
import {Avatar, Menu} from 'antd';
import {UserOutlined} from '@ant-design/icons';
import {isLoaded, isEmpty, withFirestore} from "react-redux-firebase";
import {PRIMARY_COLOR, PRIMARY_TEXT_COLOR} from "../../constants/COLORS";
import {withRouter, Link} from "react-router-dom";
import {compose} from "redux";
import {connect} from "react-redux";


const variants = {
    open: {
        transition: {staggerChildren: 0.07, delayChildren: 0.2},

    },
    closed: {
        transition: {staggerChildren: 0.05, staggerDirection: -1},

    }
};

const {SubMenu} = Menu

class Navigation extends React.Component {



    render() {
        return (
            <StyledMotionUl
                variants={variants}
                open={this.props.open}
            >
                <MenuItem>
                    <MenuHeaderDiv>
                        <img src={partnerLogo} alt="partner" className={'logo'} draggable={false}/>
                        {!isEmpty(this.props.profile) ?
                            <Link to={PROFILE_SETTINGS_URL}>
                            <div>
                                <Avatar size={100} src={this.props.profile.profileImgUrl} icon={<UserOutlined/>} />
                                <div className="name">
                                    {this.props.profile.firstN} {this.props.profile.lastN}
                                    <span className={'status'}>

                                        {this.props.profile.role === 'company' ? 'ceg' : null}
                                        {this.props.profile.role === 'employee' ? 'alkalmazott' : null}

                                    </span>
                                </div>
                            </div>
                            </Link>
                            :
                            null
                        }
                    </MenuHeaderDiv>
                </MenuItem>
                <MenuItem>
                    <MenuContainer>

                        {!isEmpty(this.props.profile) ?
                            // -------- AUTHENTICATED USER NAVBAR --------
                            <Menu
                                //onClick={this.handleClick}
                                //defaultSelectedKeys={['1']}
                                defaultOpenKeys={['sub1']}
                                mode="inline"
                                forceSubMenuRender={true}
                            >

                                <SubMenu
                                    key="sub1"
                                    icon={<NavItemImage src={callSVG} alt="call" draggable={false}/>}
                                    title={'Hivasaim'}
                                >
                                    <Menu.Item key="1"><Link to={EXCLUSIVE_CALL_URL}>bejovo hivasok</Link></Menu.Item>
                                    <Menu.Item key="2"><Link to={MY_CALLS_URL}>hivasaim</Link></Menu.Item>
                                    <Menu.Item key="3"><Link to={COMPANY_CALLS_URL}>ossszes hivas</Link></Menu.Item>
                                </SubMenu>

                                {this.props.profile.role === 'company' ?
                                    <SubMenu
                                        key="sub2"
                                        icon={<NavItemImage src={coSVG} alt="company" draggable={false}/>}
                                        title={"cegem"}
                                    >
                                        <Menu.Item key="5"><Link to={COMPANY_SETTINGS_URL}>Ceginfo</Link></Menu.Item>
                                        <Menu.Item key="6"><Link to={EMPLOYEE_REQUESTS_URL}>Alkalmazottak</Link></Menu.Item>

                                    </SubMenu>
                                    :
                                    null
                                }


                                <SubMenu
                                    key="sub3"
                                    icon={<NavItemImage src={settingsSVG} alt="settings"/>}
                                    title={"beallitasok"}
                                >
                                    <Menu.Item key="9"><Link to={PROFILE_SETTINGS_URL}>Profile</Link></Menu.Item>

                                </SubMenu>



                                <Menu.Item
                                    key="logout"
                                    icon={<NavItemImage src={logoutSVG} alt="logout"/>}
                                >
                                    <a onClick={() => {
                                        this.props.firebase.logout()

                                    }}>kilepes</a>
                                </Menu.Item>
                            </Menu>
                            // -------- AUTHENTICATED USER NAVBAR END --------
                            :
                            // -------- UNAUTHENTICATED USER NAVBAR --------
                            <Menu
                                //onClick={this.handleClick}
                                //defaultSelectedKeys={['1']}
                                defaultOpenKeys={['sub1']}
                                mode="inline"
                            >

                                <Menu.Item
                                    key="1"
                                    icon={<NavItemImage src={loginSVG} alt="login"/>}
                                >
                                    <Link to={LOGIN_URL}>Belepes</Link>
                                </Menu.Item>
                                <Menu.Item
                                    key="2"
                                    icon={<NavItemImage src={registerSVG} alt="registration"/>}
                                >
                                    <Link to={REGISTER_URL}>Regisztracio</Link>
                                </Menu.Item>
                            </Menu>
                            // -------- UNAUTHENTICATED USER NAVBAR END --------
                        }

                    </MenuContainer>
                </MenuItem>

            </StyledMotionUl>
        )
    }
}

export default compose(
    withFirestore,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),
    withRouter,
)(Navigation)

const StyledMotionUl = styled(motion.ul)`
  width: 100%;
  padding: 25px;
  position: absolute;
  margin: 0;


li {
  list-style: none;
  margin-bottom: 20px !important;
  align-items: center;
  cursor: pointer;
}


`
const MenuHeaderDiv = styled.div`
width: 100%;


.logo{
  display: block;
  width: 70%;
  margin: 2.5rem auto;
}
.ant-avatar{
background-color: transparent;
border: 5px solid ${PRIMARY_TEXT_COLOR};
display: block;
margin: 3rem auto 0;
}
.anticon-user{
  transform: translate(0, -15%);
}
.name{
  color: ${PRIMARY_TEXT_COLOR};
  font-size: 1.5rem;
  text-transform: uppercase;
  font-weight: 500;
  display: block;
  margin: 1.5rem auto;
  text-align: center;
  .status{
    font-size: 0.9rem;
    display: block;
    
  }
}
`
const MenuContainer = styled.div`
ul{
width: 100%;
overflow: hidden;
}
.ant-menu{
background-color: transparent;
color: ${PRIMARY_TEXT_COLOR};
border: none;
margin: 2rem auto;
font-size: 1.6rem;
font-weight: 500;
text-align: left;
text-transform: uppercase; 
a{
text-decoration: none;
color: ${PRIMARY_TEXT_COLOR};
}
  &-item{ 
      &::after, &::before{
          border: none !important;
       }
    &:active{
              background-color: transparent;
    }
    &-selected{
        background-color: transparent !important;
        
    }
    &-only-child{
      color: ${PRIMARY_TEXT_COLOR};
      &::after, &::before{
          border: none !important;
       }

      &:active{
              background-color: transparent;
      }
      
    }
  }
  &-submenu{
    &-title{
    margin-bottom: 1rem;
    color: ${PRIMARY_TEXT_COLOR};
        &:active{
        background-color: transparent;
        }
        span{
        user-select: none;
        cursor: pointer;
        }
        @media only screen and (max-width: 700px){
          i, i::before, i::after{
          background: white !important;
          
          }
        }
    }
    &-arrow{
      transform: scale(2) !important;
      right: 28px !important;
      &::before, &::after {
        background-image: none !important;
        background-color: white;
        transform: scale(1.3);

      }
    }
  }
  
  
}
`
const NavItemImage = styled.img`
width: 30px;
height: 30px;
margin-right: 15px;
transform: translate(0, -3px);

`
